import { BedayaAction } from '../../types/BedayaAction';
import { DpdSettings } from '../../types/DpdSettings';
import { GET_SETTINGS, PUT_SETTINGS } from '../actions/common_actions';
import { HAS_SUBSCRIPTION, POST_CHECKOUT } from '../actions/dpd_actions';

export interface IDpdState {
  settings: DpdSettings;
  isFetching: boolean;
  error: any;
  hasSubscription: boolean | undefined;
  checkoutUrl: string;
}

const initialState: IDpdState = {
  settings: {
    login: {},
    sender: {},
  },
  isFetching: false,
  error: '',
  hasSubscription: undefined,
  checkoutUrl: '',
};

export default function reducer(state: IDpdState = initialState, action: BedayaAction): IDpdState {
  switch (action.type) {
    case GET_SETTINGS.REQUEST:
    case PUT_SETTINGS.REQUEST:
      if (['dpd'].includes(action.data.system)) {
        return {
          ...state,
          isFetching: true,
        };
      }
      return state;
    case PUT_SETTINGS.SUCCESS:
      if (['dpd'].includes(action.data.system)) {
        return {
          ...state,
          settings: action.data.data,
          isFetching: false,
        };
      }
      return state;
    case GET_SETTINGS.SUCCESS:
      if (['dpd'].includes(action.data.system)) {
        return {
          ...state,
          settings: action.data.data,
          isFetching: false,
        };
      }
      return state;
    case HAS_SUBSCRIPTION.REQUEST:
    case POST_CHECKOUT.REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case HAS_SUBSCRIPTION.SUCCESS:
      return {
        ...state,
        hasSubscription: action.data.subscription,
        isFetching: false,
      };
    case POST_CHECKOUT.SUCCESS:
      return {
        ...state,
        checkoutUrl: action.data.url,
        isFetching: false,
      };
    case HAS_SUBSCRIPTION.FAILURE:
    case POST_CHECKOUT.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.data.error.toString(),
      };
    default:
      return state;
  }
}
